import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { datadogRum } from "@datadog/browser-rum";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// datadogRum.init({
//   applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || "",
//   clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "",
//   // `site` refers to the Datadog site parameter of your organization
//   // see https://docs.datadoghq.com/getting_started/site/
//   site: "us3.datadoghq.com",
//   service: process.env.REACT_APP_DATADOG_SERVICE || "",
//   env: process.env.REACT_APP_ENV || "prod",
//   // Specify a version number to identify the deployed version of your application in Datadog
//   // version: '1.0.0',
//   sessionSampleRate: 100,
//   sessionReplaySampleRate: 100,
//   defaultPrivacyLevel: "mask-user-input",
// });

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
